module.exports = __webpack_public_path__ + "img/ispringpresenter.47351dab.jpg";